import React, { useEffect, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePermissoes } from '../context/PermissoesContext';
import { useToast } from '../context/ToastContext';

// ════════════════════════════════════════════════════════════════════════════
// RotaComPermissao.jsx — r87 (Rodada C)
// ────────────────────────────────────────────────────────────────────────────
// Wrapper que verifica permissão pra acessar uma rota. Se o usuário não tem
// permissão de `visualizar` na rotina, redireciona pro Dashboard e dispara um
// toast informando.
//
// USO no App.jsx:
//   <Route path="/usuarios" element={
//     <PaginaInterna>
//       <RotaProtegida rotina="usuarios">
//         <UsuariosPage />
//       </RotaProtegida>
//     </PaginaInterna>
//   } />
//
// Enquanto as permissões ainda estão carregando (`carregando=true`), renderiza
// a tela sem bloquear (decisão pragmática: evita flash de redirect). Se quando
// terminar de carregar não tem permissão, redireciona.
// ════════════════════════════════════════════════════════════════════════════

function RotaComPermissao({ rotina, children, acao = 'visualizar' }) {
  const { pode, carregando, permissoes } = usePermissoes();
  const { mostrarToast } = useToast();
  const location = useLocation();
  const jaToastou = useRef(false);

  // Reseta o flag quando muda de rota
  useEffect(() => { jaToastou.current = false; }, [location.pathname]);

  // Aguarda carregar antes de decidir
  if (carregando || !permissoes) return children;

  if (!pode(rotina, acao)) {
    if (!jaToastou.current) {
      jaToastou.current = true;
      mostrarToast('Você não tem permissão para acessar esta rotina.', 'erro');
    }
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default RotaComPermissao;
